import { css } from 'styled-components/macro';

export default css`
  ::-webkit-scrollbar {
    width: 4px;
    background-color: ${({ theme }) => theme.palette.border.default};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c9c9c9;
    border-radius: 6px;
  }
`;
